import axios from "axios";

const baseURL = process.env.REACT_APP_PUBLIC_API ?? 'http://localhost:4000';

const publicApi = axios.create({ baseURL })

publicApi.interceptors.request.use((req) => {
  req.url = baseURL + req.url;

  return req;
});

// Add Authorization header
publicApi.interceptors.request.use((req) => {
  return req;
});

// Handle errors; redirect to login on Unauthorized
publicApi.interceptors.response.use(
  (res) => res,

  (res) => {
    const err = (res.response && res.response.data && res.response.data.error) || res;
    err.status = (res.response && res.response.status) || res.status;
    return Promise.reject(err);
  },
);

export default publicApi;